// src/prompts/p02_spalling.js — Spalling · ACI 546R / ICRI 310

export const PROMPT_P02 = (sponsorProduct = 'Sika MonoTop-910 S + Sika MonoTop-412 NFG') => `
Analyze this concrete image for SPALLING / SURFACE BREAKOUT (ACI 546R, ICRI 310).

Visual indicators:
- Exposed aggregate without paste matrix
- Missing surface layers: surface <10mm, shallow 10–25mm, deep >25mm
- Exposed reinforcement steel
- Rust staining (brown/orange streaks from rebar level)
- Probable origin: corrosion-induced, freeze-thaw, mechanical impact, overload
- Affected area: localized <0.25m², moderate 0.25–1m², extensive >1m²

Return ONLY this JSON:
{
  "pathology_id": "p02_spalling",
  "pathology_name": { "es": "Descascaramiento / Spalling", "en": "Spalling" },
  "norm": "ACI 546R / ICRI 310",
  "confidence": 88,
  "requires_additional_input": false,
  "spalling_depth": "surface|shallow|deep",
  "affected_area": "localized|moderate|extensive",
  "rebar_exposed": true,
  "probable_origin": "corrosion_induced|freeze_thaw|mechanical_impact|overload|mixed",
  "root_cause": { "es": "...", "en": "..." },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": [
        "1. Delimitar área con método de contorno (ICRI 310 saw-cut)",
        "2. Demolición hasta substrato sano: mín. 6mm + 20mm detrás de corrosión",
        "3. Si armadura expuesta: limpieza SA 2.5 + pasivador de doble componente",
        "4. Puente de adherencia epóxico sobre substrato seco",
        "5. Mortero tixotrópico R4 en capas ≤25mm. Curado húmedo 7 días."
      ],
      "en": [
        "1. Delineate repair boundary (ICRI 310 saw-cut contour method)",
        "2. Remove to sound substrate: min. 6mm + 20mm behind corrosion",
        "3. If rebar exposed: clean to SA 2.5 + apply two-component passivator",
        "4. Epoxy bonding agent on dry substrate",
        "5. Thixotropic R4 mortar in layers ≤25mm. Wet cure 7 days."
      ]
    },
    "norm_reference": "ACI 546R-14 Sec. 4; ICRI 310.2R-2013"
  },
  "materials": {
    "generic": {
      "es": "Pasivador monocomponente; puente epóxico; mortero tixotrópico fibrorreforzado",
      "en": "Single-component passivator; epoxy bonding agent; fiber-reinforced thixotropic mortar"
    },
    "premium": {
      "product": "${sponsorProduct}",
      "brand": "Sika",
      "note": { "es": "Sistema EN 1504-7 / EN 1504-3 Clase R4", "en": "System compliant EN 1504-7 / EN 1504-3 Class R4" }
    }
  },
  "linkedin_draft": { "es": "..." },
  "disclaimer": {
    "es": "La profundidad real del daño requiere sondeo físico. No sustituye inspección pericial.",
    "en": "Real damage depth requires physical probing. Does not replace expert inspection."
  }
}`;
